import { TranslationConfig } from './types';

let configCache: TranslationConfig;

export const getConfig = async (): Promise<TranslationConfig> => {
  if (configCache) {
    return configCache;
  }

  try {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const i18nModule = await import('@/i18n');
    configCache = i18nModule.default;
  } catch {
    return {
      defaultNS: 'common',
      namespaces: ['common'],
      locales: ['en-US'],
      defaultLocale: 'en-US',
      loadLocaleFrom: async () => ({}), // minimal implementation
    };
  }
  return configCache;
};

export const getNamespaces = async (locale: string) => {
  const config = await getConfig();
  return Object.fromEntries(
    await Promise.all(
      config.namespaces.map(async (ns: string) => [ns, await config.loadLocaleFrom(locale, ns)]),
    ),
  );
};
